// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2GN6s","load2":"Loader_load2__3fs2B","LoaderSecondary":"Loader_LoaderSecondary__ttR9J"};